<ion-header>
	<app-account-toolbar (back)="goBack()" src="/assets/icons-menu-modal/impressum.svg" title="menu_popover.imprint"></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<!-- Show loading spinner -->
	@if (isLoading) {
	<ion-spinner class="loading-spinner" name="dots"></ion-spinner>
	}

	<!-- Show dynamic content if available -->
	@if (useDynamicContent && legalContent) {
	<div class="legal__container o-container">
		<div [innerHTML]="legalContent" class="legal__content"></div>
	</div>
	}

	<!-- Fallback to static content if no dynamic content available -->
</ion-content>
